module.exports = __webpack_public_path__ + "img/uvb.de1afff8.png";